import script from "./applicationConstruction.vue?vue&type=script&setup=true&lang=js"
export * from "./applicationConstruction.vue?vue&type=script&setup=true&lang=js"

import "./applicationConstruction.vue?vue&type=style&index=0&id=12338ae7&scoped=true&lang=css"

import exportComponent from "/workspace/cgsfront/cgs-office-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12338ae7"]])

export default __exports__